<script setup lang="ts">
import { useAppStore } from "@/stores/App";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const appStore = useAppStore();

function goBack() {
  history.back();
}

emitter.on("languageUpdated", init);
onMounted(init);

function init() {
  appStore.updateTitleAndDescription({
    title: t("SV.LIT_PageNotFound"),
    description: '',
  });
}
</script>

<template>
  <FullScreenMessage
    :title="$t('SV.MES_PageNotFoundTitle')"
    icon="fa-thin fa-circle-question"
  >
    <p>{{ $t("SV.MES_PageNotFound_ThingsToTry") }}</p>
    <ul class="list-disc pl-5">
      <li>{{ $t("SV.MES_PageNotFound_ThingsToTry_CheckUrl") }}</li>
      <li>
        <i18n-t
          keypath="SV.MES_PageNotFound_ThingsToTry_GoBack"
          scope="global"
        >
          <template #action>
            <a
              href="#"
              @click.stop.prevent="goBack()"
              >{{ $t("SV.LIT_GoingBack") }}</a
            >
          </template>
        </i18n-t>
      </li>
      <li>
        <i18n-t
          keypath="SV.MES_PageNotFound_ThingsToTry_HomePage"
          scope="global"
        >
          <template #homepage>
            <router-link to="/">{{ $t("SV.LIT_HomePage") }}</router-link>
          </template>
        </i18n-t>
      </li>
    </ul>
  </FullScreenMessage>
</template>

<style scoped lang="postcss">
a {
  @apply link transition-all hover:text-primary;
}
</style>
